import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Login from "./Login";
import StatusPage from "./Status";
import Register from "./Register";
import ErrorPage from "./ErrorPage";
import Admin from "./Admin";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { signature, cowSay } from "./utils/Console";
import "./index.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App station={"YKU"} />,
    errorElement: <ErrorPage />,
  },
  {
    path: "status",
    element: <StatusPage />,
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "register",
    element: <Register />,
  },
  {
    path: "admin",
    element: <Admin />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

cowSay(signature);
console.log(`Node env : ${process.env.NODE_ENV}`);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
